module.exports = __webpack_public_path__ + "static/img/help_chm.a5fd310.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/help_chm.png
// module id = 886
// module chunks = 1